// client/src/utils/apiBase.ts
//
// URL base delle API, risolto in UN SOLO posto per tutta l'app.
//
// PERCHÉ ESISTE (9 Ott 2026): la build della CI passava `VITE_API_URL` come
// stringa VUOTA (secret non configurato) e le copie sparse nel codice usavano
// `??` — l'operatore nullish NON scatta su stringa vuota, quindi `API_BASE`
// restava `""` e le fetch partivano con URL relativi. Dentro una WebView
// Capacitor un URL relativo risolve su `https://localhost/api/...`: l'app
// mostrava "server non raggiungibile" e il login era impossibile.
//
// REGOLE (in ordine):
//   1. `VITE_API_BASE_URL` (canonica) oppure `VITE_API_URL` (legacy) — solo se
//      valorizzate DAVVERO (dopo trim, lunghezza > 0);
//   2. in sviluppo, senza env: stringa vuota → si passa dal proxy di Vite;
//   3. nei build distribuiti (APK/web) senza env: fallback sull'URL di
//      produzione, perché un build senza variabili deve restare FUNZIONANTE.

/** Endpoint pubblico di produzione (nessun segreto: è già nel bundle web). */
export const PRODUCTION_API_BASE_URL = "https://rideconnect-api-ktte.onrender.com";

/**
 * Risolve l'URL base delle API. Non cachea: legge `import.meta.env` a ogni
 * chiamata, così i test possono sovrascrivere la variabile con `vi.stubEnv`.
 *
 * Il riconoscimento dello "sviluppo" usa `MODE` (stringa): in dev server vale
 * `development`, nei build vale `production`/`staging`, nei test `test` — così
 * un build senza variabili non eredita mai l'URL relativo del dev server.
 */
export function resolveApiBaseUrl(): string {
  const raw =
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
    (import.meta.env.VITE_API_URL as string | undefined);
  // `||` (non `??`): una stringa vuota/whitespace vale come "non impostata".
  const trimmed = (raw ?? "").trim().replace(/\/+$/, "");
  if (trimmed.length > 0) return trimmed;
  const isDevServer = import.meta.env.MODE === "development";
  return isDevServer ? "" : PRODUCTION_API_BASE_URL;
}
